import * as React from 'react'

import FinalParentSignUpForm, {
  isFinalParentSignUpFormRequired,
} from 'main/components/common/AuthModal/parent/FinalParentSignUpForm'
import { Button } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../../common'
import { i18nKeyPrefix } from '../../../i18n'
import { AuthenticatedUser } from '../../types'

interface IProps {
  user: AuthenticatedUser
  onComplete: () => void
}

const PRE = `${i18nKeyPrefix}-CONTACT-MODAL-STEP-CONFIRM`

export default function Confirmation(props: IProps) {
  const { user, onComplete } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return isFinalParentSignUpFormRequired(user) ? (
    <FinalParentSignUpForm user={user} displayPhoneField onComplete={onComplete} />
  ) : (
    <Button onClick={() => onComplete()} full>
      {t(`${PRE}-DONE`)}
    </Button>
  )
}
